import React from "react"
import uuid from "uuid"
import get from "lodash/get"
import { connect } from "react-redux"
import styled from "styled-components"

import {
  fetchData,
  removeData,
  showToast,
  showPopup,
  hidePopup,
} from "../../store/action"
import PrimaryButton from "../../components/buttons/PrimaryButton"
import { maxBid, minBid } from "../../site-settings.js"
import PageHeader from "../PageHeader"
import BidNumbers from "./BidNumbers"
import config from "../../Config"
import i18n from "../../i18n"
import Cookie from "../../util/Cookie"
import ExpenisonPanelView from "../../components/ExpenisonPanel"
import { replaceWithSymbol } from "../../util/cutString"

const Body = styled.div`
  height: calc(100% - 280px);
  overflow-y: scroll;
  padding-left: 20px;
  padding-right: 20px;
`

const RangeText = styled.div`
  padding: 25px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  height: 25px;
`

const RangeChooser = styled.div`
  background-color: #f3f3f3;
  overflow-x: scroll;
  display: flex;
  width: 90%;
`

const ValueHolder = styled.div`
    height: 35px
    min-width: 53px
    border-radius: 8px;
    margin: 16px 0px 16px 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: montserratRegular;
`

const PlaceBidButton = styled.div`
  display: flex;
  position: fixed;
  bottom: 0px;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-shadow: 0 -5px 5px -5px #3333336b;
  background-color: #1c1d23;
  height: 90px;
`

const ModalContainer = styled.div`
  display: flex;
  background-color: #ffffff;
  flex-direction: column;
  padding: 10px 20px;
  border-radius: 5px;
`

const ModalHeader = styled.div`
  padding: 10px;
`

const ModalMsg = styled.div`
  padding: 10px;
`

const ModalActionsWrapper = styled.div`
  display: flex;
  padding: 10px;
  justify-content: flex-end;
`

const ModalActions = styled.a`
  color: #2ebaaa;
  margin-left: 25px;
`

const ScrollWrapper = styled.div`
  width: 5%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const SelectBidInfo = styled.span`
  font-size: 12px;
  margin-top: 2px;
`

const Text = styled.span`
  font-size: ${(props) => `${props.size}px`};
`

const SelectBidText = styled.div`
  padding: 15px;
  display: flex;
  height: 40px;
  flex-direction: column;
  margin-top: 10px;
`

const BidRange = styled.div`
  display: flex;
  height: 70px;
  padding-left: 20px;
  padding-right: 20px;
`

const AnimationArrow = styled.img`
  animation-iteration-count: infinite;
  width: 10px;
  display: flex;
`

const BidValueWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 20px 150px 20px;
`

const ConfirmationModal = ({ selectedBidCount, hidePopup, placeMyBid }) => {
  return (
    <ModalContainer>
      <ModalHeader className='montserratSemiBold'>
        {i18n.t("ConfirmBid")}
      </ModalHeader>
      <ModalMsg className='montserratLight'>
        {i18n.t("SurePlaceBids") +
          " " +
          `${selectedBidCount}` +
          " " +
          i18n.t("bids") +
          `?`}
      </ModalMsg>
      <ModalActionsWrapper className='montserratLight'>
        <ModalActions className='pointer' onClick={hidePopup}>
          {i18n.t("No")}
        </ModalActions>
        <ModalActions
          className='pointer'
          onClick={() => {
            hidePopup()
            placeMyBid()
          }}
        >
          {i18n.t("Yes")}
        </ModalActions>
      </ModalActionsWrapper>
    </ModalContainer>
  )
}

class PlaceBids extends React.Component {
  constructor(props) {
    super(props)
    this.bidNumbers = []
    this.loadData = this.loadData.bind(this)
    this.getBidOption = this.getBidOption.bind(this)
    this.onSelectBid = this.onSelectBid.bind(this)
    this.placeMyBid = this.placeMyBid.bind(this)
    this.onSelectActualBidNum = this.onSelectActualBidNum.bind(this)
    this.isActualBidSelected = this.isActualBidSelected.bind(this)
    this.showBidLimitCrossMsg = this.showBidLimitCrossMsg.bind(this)
    this.onScrollLeft = this.onScrollLeft.bind(this)
    this.onScrollRight = this.onScrollRight.bind(this)
    this.initializeState = this.initializeState.bind(this)
    this.state = this.initializeState()
  }

  componentWillMount() {
    this.loadData()
  }

  componentWillUnmount() {
    const { removeData, uniqueId } = this.props
    removeData({
      uniqueId,
    })
  }

  loadData() {
    const { fetchData, uniqueId } = this.props
    const { selectedIndex } = this.state
    fetchData({
      uniqueId,
      method: "GET",
      uri: `/userBids/${get(this.props, "match.params.offerId")}`,
      onSuccess: (res) => {
        // console.log("PlaceBids res-->>",res)
        this.bidNumbers = []
        this.getBidOption(0, res.maxRange)
        this.setState(
          this.initializeState(
            res.bidsRemaining,
            selectedIndex,
            res.maxPermissibleBids
          )
        )
      },
    })
  }

  initializeState(
    bidsRemaining = 0,
    selectedIndex = null,
    maxPermissibleBids = 50
  ) {
    // console.log("initializeState selectedIndex -->>",selectedIndex);
    return {
      bidsRemaining: bidsRemaining,
      bidsRemainingCount: bidsRemaining,
      selectedIndex: selectedIndex,
      bidValues: [],
      maxPermissibleBids: maxPermissibleBids,
    }
  }

  getBidOption(minBid = 0, maxBid = 99) {
    let x = minBid
    while (x <= maxBid) {
      this.bidNumbers.push(x)
      x++
    }
  }

  isActualBidSelected() {
    return this.state.bidsRemaining == this.state.bidsRemainingCount
  }

  onSelectBid(index) {
    // const { selectedIndex,bidsRemaining} = this.state;
    this.setState({
      selectedIndex: index,
    })
    // if(selectedIndex !== index){
    //     if(!this.isActualBidSelected()) {
    //         const { showToast } = this.props;
    //         showToast({
    //             text: "Previously selected bids have been deselected.",
    //             variant: "info",
    //         });
    //     }
    // }
  }

  onSelectActualBidNum(selectedIndex, value) {
    let { bidsRemainingCount, bidValues, maxPermissibleBids } = this.state
    const temp1 = [...bidValues]
    const valueIndex = temp1.indexOf(value)

    if (valueIndex < 0) {
      temp1.push(value)
      if (temp1.length > maxPermissibleBids) {
        this.showBidLimitCrossMsg()
        return
      }

      if (bidsRemainingCount > 0) {
        this.setState({
          bidValues: temp1,
          bidsRemainingCount: --bidsRemainingCount,
        })
      } else {
        const { showToast } = this.props
        showToast({
          text: i18n.t("NoBidAvailable"),
          variant: "warning",
        })
      }
    } else {
      temp1.splice(valueIndex, 1)
      this.setState({
        bidValues: temp1,
        bidsRemainingCount: ++bidsRemainingCount,
      })
    }
  }

  showBidLimitCrossMsg() {
    const { showToast } = this.props
    showToast({
      text: i18n.t("NoMoreSelection") + ` ${this.state.maxPermissibleBids}`,
      variant: "warning",
    })
  }

  placeMyBid() {
    console.log("checkprops", this.props)
    const { fetchData, showToast } = this.props
    const offerId = get(this.props, "match.params.offerId")
    const offerTitle = get(this.props, "match.params.title")

    if (this.state.bidValues.length <= this.state.maxPermissibleBids) {
      fetchData({
        method: "POST",
        uri: `/placeBid/${offerId}`,
        withUserCredentials: true,
        params: {
          bids: this.state.bidValues.toString(),
        },
        onSuccess: (res) => {
          // console.log("placeMyBid res-->>",res)
          this.props.history.push({
            pathname: `/play/bid-placed-successfully/${replaceWithSymbol(
              offerTitle
            )}/${offerId}`,
            state: {
              bidsString: this.state.bidValues.toString(),
              bidsArray: this.state.bidValues,
            },
          })
          // showToast({
          //   text: i18n.t("BidSubmitted"),
          //   variant: "success",
          // })
          this.loadData()
        },
      })
    } else {
      this.showBidLimitCrossMsg()
    }
  }

  onScrollLeft(event) {
    let screenWidth = window.screen.width
    if (screenWidth > 1000) screenWidth = 410
    document.getElementById("bidNumbers").scrollLeft += screenWidth - 70
  }

  onScrollRight(event) {
    let screenWidth = window.screen.width
    if (screenWidth > 1000) screenWidth = 410
    document.getElementById("bidNumbers").scrollLeft -=
      window.screen.width > 1000 ? 410 : window.screen.width - 70
  }

  render() {
    console.log("checkprops", this.props)
    console.log("checkstate", this.state)

    const { data, showPopup, hidePopup, theme } = this.props
    const { selectedIndex, bidValues, bidsRemaining } = this.state
    const selectedBidCount = bidValues.length
    if (!data) {
      return null
    } else if (data.error) {
      return <span>{data.error}</span>
    }
    console.log("PlaceMyBid props -->>", this.props)
    console.log("selectedIndex", selectedIndex)
    return (
      <div
        className='wrapper'
        style={{ backgroundColor: theme.secondaryColor }}
      >
        <PageHeader
          backLocation={`/play/product-details/${get(
            this.props,
            "match.params.title"
          )}/${get(this.props, "match.params.offerId")}`}
          label={i18n.t("Place Bids")}
          bidBalance={bidsRemaining}
          theme={theme}
        />
        <div className='container_body'>
          <RangeText>
            <Text
              className='montserratRegular'
              size={16}
              style={{ fontWeight: 500, color: "#fff", paddingLeft: "20px" }}
            >
              {i18n.t("ChooseRange")}
            </Text>
          </RangeText>
          <BidValueWrapper>
            {/* <ExpenisonPanelView bidValue={true} title={"02"}>
            02
          </ExpenisonPanelView>

          <ExpenisonPanelView bidValue={true} title={"03"}>
            03
          </ExpenisonPanelView> */}
            {this.bidNumbers.map((num, index) => {
              console.log("selectedIndex 2", index)
              return (
                <ExpenisonPanelView
                  key={num}
                  bidValue={true}
                  title={num <= 9 ? "0" + num : num}
                  onClick={() => this.onSelectBid(index)}
                  theme={theme}
                  //   className={
                  //     selectedIndex === index ? "activeBid" : "inactiveBid"
                  //   }
                  activeClass={
                    selectedIndex === index ? "activeBid" : "inactiveBid"
                  }
                >
                  <BidNumbers
                    selcetedBidNum={selectedIndex}
                    onSelectActualBidNum={this.onSelectActualBidNum}
                    preSelectedBid={get(data, "data.bidDetails", [])}
                    showToast={(obj) => this.props.showToast(obj)}
                    selectedBidValues={bidValues}
                  />
                </ExpenisonPanelView>
                // <ValueHolder
                //   onClick={() => this.onSelectBid(index)}
                //   className={
                //     selectedIndex === index ? "activeBid" : "inactiveBid"
                //   }
                //   key={index}
                // >
                //   <Text size={16}>{num}</Text>
                // </ValueHolder>
              )
            })}
          </BidValueWrapper>
          {/* <BidRange>
          <ScrollWrapper>
            <button
              style={{ height: 70 }}
              onClick={this.onScrollRight}
              className='btn-scroll'
            >
              <AnimationArrow
                src={`${config.MRBIDNWIN_S3_IMAGE_URL}/range-left.svg`}
                alt='bid-range-left-arrow'
              />
            </button>
          </ScrollWrapper>
          <RangeChooser id='bidNumbers' ref='bidNumbers' className='hideScroll'>
            {this.bidNumbers.map((num, index) => {
              return (
                <ValueHolder
                  onClick={() => this.onSelectBid(index)}
                  className={
                    selectedIndex === index ? "activeBid" : "inactiveBid"
                  }
                  key={index}
                >
                  <Text size={16}>{num}</Text>
                </ValueHolder>
              )
            })}
          </RangeChooser>
          <ScrollWrapper>
            <button
              style={{ height: 70 }}
              onClick={this.onScrollLeft}
              className='btn-scroll'
            >
              <AnimationArrow
                src={`${config.MRBIDNWIN_S3_IMAGE_URL}/range-right.svg`}
                alt='bid-range-right-arrow'
              />
            </button>
          </ScrollWrapper>
        </BidRange> */}
          {/* <SelectBidText>
          <Text className='montserratSemiBold' size={16}>
            {i18n.t("SelectBid")}
          </Text>
          <SelectBidInfo className='montserratLight'>
            {i18n.t("SelectBidInfo")}
          </SelectBidInfo>
        </SelectBidText> */}
          {/* <Body>
          <BidNumbers
            selcetedBidNum={selectedIndex}
            onSelectActualBidNum={this.onSelectActualBidNum}
            preSelectedBid={get(data, "data.bidDetails", [])}
            showToast={(obj) => this.props.showToast(obj)}
            selectedBidValues={bidValues}
          />
        </Body> */}
          <PlaceBidButton className='setWidth'>
            <PrimaryButton
              style={{
                height: 54,
                width: "70%",
                color: "#fff",
                backgroundColor: this.isActualBidSelected()
                  ? "#808080c9"
                  : "#f32c2c",
              }}
              variant='contained'
              label={i18n.t("PlaceBids") + " " + `(${selectedBidCount})`}
              disabled={this.isActualBidSelected()}
              onClick={() =>
                showPopup({
                  renderComponent: () => (
                    <ConfirmationModal
                      selectedBidCount={selectedBidCount}
                      placeMyBid={this.placeMyBid}
                      hidePopup={hidePopup}
                    />
                  ),
                  showPopup: true,
                })
              }
            />
          </PlaceBidButton>
        </div>
      </div>
    )
  }
}

PlaceBids = connect(
  (state, ownProps) => {
    let mapStateToProps = {}
    if (state.data && state.data[ownProps.uniqueId]) {
      mapStateToProps.data = state.data[ownProps.uniqueId]
      mapStateToProps.theme = state.theme
    }
    return mapStateToProps
  },
  {
    fetchData,
    removeData,
    showToast,
    showPopup,
    hidePopup,
  }
)(PlaceBids)

export default class PlaceBidsWrapper extends React.Component {
  componentWillMount() {
    this.uuid = uuid.v4()
    const locale = Cookie.get("X-Reycreo-Language-Id")
    i18n.changeLanguage(locale || "en")
    console.log("RENDER PlaceBidsWrapper :: ", locale)
  }

  render() {
    return <PlaceBids {...this.props} uniqueId={this.uuid} />
  }
}



// WEBPACK FOOTER //
// ./src/views/PlaceBids/index.js